module.exports = __webpack_public_path__ + "media/images/icon-arrowdown-105e5e580acb91f72faba9f8d9fb0c88.png";